import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function OverallRiskScoreChartIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 36 36"
      fill="none"
    >
      <path
        d="M27.5339 15.0693C28.5488 16.5738 29.1931 18.2972 29.4143 20.0985C29.6355 21.8998 29.4272 23.7279 28.8065 25.4332"
        stroke="#927BF0"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M7.19354 25.4332C6.48914 23.4979 6.31739 21.4089 6.69624 19.3846C7.0751 17.3602 7.99064 15.4747 9.34723 13.9251C10.7038 12.3755 12.4517 11.2186 14.4081 10.5753C16.3646 9.93206 18.458 9.82602 20.4695 10.2683"
        stroke="#927BF0"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M24.2633 11.8553C24.3644 11.9209 24.4643 11.9881 24.5632 12.0568"
        stroke="#CCBFFF"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M20.5 22.5C21.3284 22.5 22 23.1716 22 24C22 24.8284 21.3284 25.5 20.5 25.5L14.5 25.5C13.6716 25.5 13 24.8284 13 24C13 23.1716 13.6716 22.5 14.5 22.5L20.5 22.5Z"
        fill="#CCBFFF"
      />
    </svg>
  );
};
